import { css } from "@emotion/react";

import { responsiveBreakpoint } from "@constants";

export const rowCompanyInfo = css`
  margin-bottom: 16px;

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    margin-bottom: 10px;
  }
`;

export const companyInfo = css`
  font-family: Apple SD Gothic Neo;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.2px;
  word-break: keep-all;
  color: var(--gray-500);
  margin-bottom: 16px;

  a {
    font-weight: 500;
  }
`;

export const responsivility = css`
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: -0.2px;
  color: var(--gray-500);

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    width: calc(100% - 80px);
  }
`;
